import React from 'react';
import { FiArrowRight, FiCheckCircle, FiShield, FiTrendingUp } from 'react-icons/fi';
import ContactForm from './ContactForm';

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-slate-50">
      <div className="absolute inset-x-0 top-0 h-[560px] bg-[radial-gradient(circle_at_top_left,_rgba(99,102,241,0.16),_transparent_42%),radial-gradient(circle_at_top_right,_rgba(14,165,233,0.16),_transparent_38%)]" />
      <div className="absolute right-[-120px] top-16 hidden h-72 w-72 rounded-full bg-indigo-100 blur-3xl lg:block" />

      <div className="relative mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-6 lg:grid-cols-[1.08fr_0.92fr] lg:px-8 lg:py-24">
        <div className="flex flex-col justify-center">
          <div className="inline-flex w-fit items-center gap-2 rounded-full border border-indigo-200 bg-white px-4 py-2 text-xs font-semibold uppercase tracking-[0.24em] text-indigo-700 shadow-sm">
            Online cancellation service
          </div>

          <h1 className="mt-6 max-w-3xl text-4xl font-semibold leading-tight tracking-tight text-slate-950 sm:text-5xl lg:text-6xl">
            CANCEL YOUR SUBSCRIPTION FREE AND IMMEDIATELY THROUGH OUR ONLINE CANCELLATION SERVICE.
          </h1>

          <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-600">
            Our operators are trained by our partners to answer all your questions quickly and efficiently.
          </p>
          <p className="mt-4 max-w-2xl text-base leading-8 text-slate-600">
            The subscription services that we provide offer our customers a unique solution to multiple problems.
          </p>

          <div className="mt-8 grid gap-3 sm:grid-cols-3">
            <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
              <div className="flex items-center gap-2 text-sm font-medium text-slate-900">
                <FiCheckCircle className="h-4 w-4 text-indigo-600" />
                Simplified support
              </div>
              <p className="mt-2 text-sm leading-6 text-slate-600">Reach your customer account in one click and manage your subscription information.</p>
            </div>
            <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
              <div className="flex items-center gap-2 text-sm font-medium text-slate-900">
                <FiShield className="h-4 w-4 text-indigo-600" />
                Recognized expertise
              </div>
              <p className="mt-2 text-sm leading-6 text-slate-600">We provide the after-sales service of several partner sites and support every single client.</p>
            </div>
            <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
              <div className="flex items-center gap-2 text-sm font-medium text-slate-900">
                <FiTrendingUp className="h-4 w-4 text-indigo-600" />
                Agents at your service
              </div>
              <p className="mt-2 text-sm leading-6 text-slate-600">Our agents are experts in after-sales services and answer your questions quickly.</p>
            </div>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-4 text-sm text-slate-600">
            <div className="inline-flex items-center gap-2 rounded-full bg-slate-900 px-4 py-2 font-medium text-white">
              Contact us
              <FiArrowRight className="h-4 w-4" />
            </div>
            <span>Support for subscription management, cancellation, and partner-site questions.</span>
          </div>
        </div>

        <div className="relative flex items-center justify-center lg:justify-end">
          <div className="absolute right-0 top-0 hidden h-48 w-48 rounded-[2rem] bg-[url('https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&q=80&w=600')] bg-cover bg-center shadow-2xl lg:block" />
          <div className="relative z-10 w-full max-w-md pt-0 lg:pt-20">
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
}
